import { Box, rgba } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { SignUpForm as SignUpType } from "../../hooks/useSignUpController";
import { FormTextInput } from "@/design-system/components/form/FormTextInput";
import { FormPasswordInput } from "@/design-system/components/form/FormPasswordInput";
import { PasswordStrength } from "@/components/PasswordStrength";
import { PASSWORD_LEVELS } from "@/core/constants";

interface SignUpProps {
  form: UseFormReturnType<SignUpType>;
  onSubmit: () => void;
  formId: string;
}

export const SignUpForm = ({ form, onSubmit, formId }: SignUpProps) => {
  const emailInput = form.getInputProps("email");
  const passwordInput = form.getInputProps("password");

  return (
    <form
      id={formId}
      onSubmit={form.onSubmit(onSubmit)}
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}>
      <FormTextInput
        type="email"
        label="E-mail"
        c={rgba("var(--mantine-color-plain_text-0)", 0.5)}
        placeholder="Digite seu e-mail..."
        size="md"
        required
        withAsterisk={false}
        withErrorStyles={false}
        styles={{ input: { border: "none" } }}
        {...emailInput}
      />
      <FormPasswordInput
        label="Senha"
        c={rgba("var(--mantine-color-plain_text-0)", 0.5)}
        placeholder="Digite sua senha..."
        size="md"
        required
        withAsterisk={false}
        withErrorStyles={false}
        styles={{ input: { border: "none" } }}
        {...passwordInput}
      />
      <Box w={"100%"}>
        <PasswordStrength
          showStrength={form.values.password.trim().length > 0}
          reserveStrengthRow
          levels={PASSWORD_LEVELS}
          password={passwordInput.value}
        />
      </Box>
      <FormPasswordInput
        mt={20}
        label="Confirme sua senha"
        c={rgba("var(--mantine-color-plain_text-0)", 0.5)}
        placeholder="Confirme sua senha..."
        size="md"
        required
        withAsterisk={false}
        withErrorStyles={false}
        styles={{ input: { border: "none" } }}
        {...form.getInputProps("passwordConfirmation")}
      />
    </form>
  );
};
